import React from 'react'
import PropTypes from 'prop-types'
import Button from 'semantic-ui-react/dist/commonjs/elements/Button'

const PayCardButton = ({ onClick }) => (
  <Button
    color='green'
    compact
    content="Card"
    onClick={() => onClick('card')}
  />
)

PayCardButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default PayCardButton
